module.exports = __webpack_public_path__ + "media/images/image4-74bd6ed5434991c3ec78f5a296cfa440.png";